import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';

const TicketDropdown = ({ field, options, label, disabled, onChange }) => {
  return (
    <div className="ticket-dropdown">
      <label htmlFor={field.name}>{label}</label>
      <select
        {...field}
        onChange={event => {
          if (onChange) {
            onChange(event);
          }

          field.onChange(event);
        }}
        disabled={disabled}
      >
        <option value="" />,
        {options.map(({ code, name }) => (
          <option key={code} value={code}>
            {name}
          </option>
        ))}
      </select>
      <ErrorMessage className="update-message" component="span" name={field.name} />
    </div>
  );
};

TicketDropdown.propTypes = {
  field: PropTypes.object,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string
    })
  ),
  label: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};

export default TicketDropdown;
